%disabled {
  opacity: 0.5;
  pointer-events: none;
}

%enabled {
  opacity: 1;
  pointer-events: initial;
}

body.readOnly {
  :global(.record-meta),
  :global(.record-associations) {
    & > div {
      @extend %disabled;
    }

    // enable links in associations panels
    :global(.record-field[class*=-associations]),
    :global(.associations-panel),
    :global(.artist-parent) {
      @extend %enabled;

      label,
      :global(.association-add),
      :global(.association-remove-button),
      :global(.panel-title) {
        @extend %disabled;
      }
    }

    // enable link to Library page
    :global(.actions) {
      @extend %enabled;

      :global(.actions-list) > div:not(:global(.action-library-link)) {
        @extend %disabled;
      }
    }

    // enable links in document panel
    // Too messy -- let's leave this for now
    // :global(.doc-panel) {
    //   opacity: 1;
    //   pointer-events: initial;

    //   :global(.panel-title),
    //   :global(#doc-dropzone-upload-button),
    //   input[class$=_Editor__input],
    //   [class$=DocActions-_styles__actions] {
    //     opacity: 0.25;
    //     pointer-events: none;
    //   }
    // }
  }
}
